import SettingsContent from '../Wrapper';
import Index from './Index';
import { frontendURL } from '../../../../helper/URLHelper';

// Product, topic and competitor labels used to live on their own settings
// screens; keep their old URLs working by redirecting to the matching tab.
const LEGACY_LABEL_TYPE_PATHS = {
  product_labels: 'products',
  topic_labels: 'topics',
  concurrent_labels: 'concurrents',
};

const legacyLabelTypeRedirects = Object.entries(
  LEGACY_LABEL_TYPE_PATHS
).flatMap(([legacyPath, tab]) =>
  ['', '/list'].map(suffix => ({
    path: frontendURL(`accounts/:accountId/settings/${legacyPath}${suffix}`),
    redirect: to => ({
      name: 'labels_list',
      params: to.params,
      query: { tab },
    }),
  }))
);

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels'),
      component: SettingsContent,
      props: {
        headerTitle: 'LABEL_MGMT.HEADER',
        icon: 'tag',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'labels_wrapper',
          roles: ['administrator', 'supervisor'],
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'labels_list',
          roles: ['administrator', 'supervisor'],
          component: Index,
        },
      ],
    },
    ...legacyLabelTypeRedirects,
  ],
};
